import { InputText, type InputTextProps } from '@carboncopyco/ui';
import { useFormContext } from 'react-hook-form';
import { CharactersCounter, ErrorMessage, FormField } from './FormField';
import { ruleNameSchema } from './schema';

export type RuleNameFieldProps = Pick<InputTextProps, 'autoFocus'>;

const fieldName = 'name';
const fieldLabel = ruleNameSchema([]).describe().label;
const maxChars = ruleNameSchema([])
  .describe()
  .tests.find((constraint) => constraint.name === 'max')?.params?.max as number;

export const RuleNameField = ({ autoFocus }: RuleNameFieldProps) => {
  const {
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(fieldName);

  return (
    <FormField
      name={fieldName}
      label={fieldLabel}
    >
      <InputText
        onChange={(e) => {
          setValue(fieldName, e.target.value, {
            shouldDirty: true,
          });
          trigger(fieldName);
        }}
        autoFocus={autoFocus}
        state={errors[fieldName] ? 'error' : 'normal'}
      />
      <div className="flex leading-ds-200">
        <ErrorMessage errors={errors} />
        <div className="ml-auto">
          <CharactersCounter
            current={value?.length}
            max={maxChars}
          />
        </div>
      </div>
    </FormField>
  );
};
